import React from 'react';

export default function Footer() {
  const date = new Date();

  return (
    <footer className="bg-light text-dark mt-auto pt-4">
      <div className="container">
        <div className="row">

          {/* SOL TARAF */}
          <div className="col-md-6 mb-4">
            <h5>Lale Kuruyemişçi</h5>
            <p className="mb-1">İstanbul, Türkiye</p>
            <p className="mb-3">Email: </p>

            <h6>Working Hours</h6>
            <p className="mb-1">Mon - Fri: 10:00 AM - 1:00 AM</p>
            <p className="mb-0">Sat - Sun: 10:00 AM - 3:00 AM</p>
          </div>

          {/* SAĞ TARAF */}
          <div className="col-md-6 mb-4 text-md-end">
            <h6>Follow Us</h6>
            <div className="mb-3">
              <a
                href=""
                className="me-3 text-dark"
              >
                <i className="bi bi-facebook fs-4"></i>
              </a>
              <a
                href=""
                className="me-3 text-dark"
              >
                <i className="bi bi-instagram fs-4"></i>
              </a>
              <a
                href=""
                className="text-dark"
              >
                <i className="bi bi-twitter fs-4"></i>
              </a>
            </div>

            <h6>Contact Us</h6>
            <p className="mb-1">Phone: +90 </p>
            <p className="mb-0">Phone: +90 </p>
          </div>

        </div>

        <hr />

        <div className="text-center pb-3">
          © {date.getFullYear()} Lale Kuruyemişçi. Tüm Hakları Saklıdır.
        </div>
      </div>
    </footer>
  );
}
